"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorMessages = void 0;
var ErrorMessages = exports.ErrorMessages = /*#__PURE__*/function (ErrorMessages) {
  ErrorMessages["Error"] = "";
  ErrorMessages["InvalidToken"] = "InvalidToken";
  ErrorMessages["PlayerLocked"] = "PlayerLocked";
  ErrorMessages["InvalidPlayerId"] = "InvalidPlayerId";
  ErrorMessages["APIDown"] = "APIDown";
  ErrorMessages["InvalidGameMathModelId"] = "InvalidGameMathModelId";
  ErrorMessages["InsufficientBalance"] = "InsufficientBalance";
  ErrorMessages["LimitsReached"] = "LimitsReached";
  ErrorMessages["TimeLimitReached"] = "TimeLimitReached";
  ErrorMessages["InvalidBet"] = "InvalidBet";
  ErrorMessages["InvalidPromotionBet"] = "InvalidPromotionBet";
  ErrorMessages["ContactSupport"] = "ContactSupport";
  ErrorMessages["SpinError"] = "SpinError";
  ErrorMessages["Timeout"] = "Timeout";
  ErrorMessages["BadResponse"] = "BadResponse";
  ErrorMessages["InvalidExpiredSession"] = "InvalidExpiredSession";
  ErrorMessages["GameInEarlyAccess"] = "GameInEarlyAccess";
  ErrorMessages["GameUnavailable"] = "GameUnavailable";
  ErrorMessages["CountryBlocked"] = "CountryBlocked";
  ErrorMessages["ReplayRoundIdNotFound"] = "ReplayRoundIdNotFound";
  return ErrorMessages;
}({});
//# sourceMappingURL=ErrorMessages.js.map